<template>
  <div class="estimateCard">
    <p class="p_text font_bold">{{ aminoAcidName }}氨基酸、钙、磷需要量</p>
    <a-table
      :scroll="{ x: 200 }"
      :columns="columns"
      :data-source="list"
      class="estimateTable"
      :pagination="false"
      row-key="id"
    >
      <template slot="name" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            {{ text }}
          </template>
          {{ text }}
        </a-tooltip>
      </template>
      <template v-for="el in fixedArr" :slot="el" slot-scope="text">
        <span :key="el">{{
          text && text !== "-" ? Number(text).toFixed(2) : text || ""
        }}</span>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  aminoAcidColums,
  aminoAcidList,
} from "../../../../EstimateConfig/estimateConfig";
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from 'vuex'
export default {
  props: ["isAdd", "resId", "tabKey", "details",'predictionTypeCode'],
  data() {
    return {
      list: [],
      sectionList: [],
      aminoAcidList,
      estimateId: getRequest("id"),
      fixedArr: [],
      aminoAcidName: "", //保存当前氨基酸名称
      animationP: "", //保存磷模型
      formulaNameArray: [], //配方名称
    };
  },
  computed: {
    ...mapState('estimate',['dataDictionary']),
     columns() {
      let newColumns = [...aminoAcidColums];
      if (this.sectionList.length > 1) {
        this.sectionList.forEach((el, index) => {
          newColumns.push({
            title: el.name,
            children: [
              {
                title: "日粮需要量水平（%）",
                dataIndex: `avg${el.field}Req`,
                scopedSlots: { customRender: `avg${el.field}Req` },
                width: 100,
              },
              {
                title: `当前阶段日粮含量(%)（配方：[ ${
                  this.formulaNameArray[index] == undefined
                    ? ""
                    : this.formulaNameArray[index].formulaName
                }]`,
                dataIndex: `Diet${el.field}`,
                scopedSlots: { customRender: `Diet${el.field}` },
                width: 200,
              },
            ],
          });
        });
      } else {
        this.sectionList.forEach((el, index) => {
          newColumns.push({
            title: "日粮需要量（%）",
            dataIndex: `avg${el.field}Req`,
            scopedSlots: { customRender: `avg${el.field}Req` },
            width: 100,
          });
          newColumns.push({
              title: `当前日粮含量(%)（配方：[ ${
                this.formulaNameArray[index] == undefined
                  ? ""
                  : this.formulaNameArray[index].formulaName
              }]`,
              dataIndex: `Diet${el.field}`,
              scopedSlots: { customRender: `Diet${el.field}` },
              width: 200,
          });   
        });
      }

      return newColumns;
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    resId(val) {
      if (val) {
        this.getDetails(val);
        this.getName(val);
      }
    },
    tabKey() {
      if (this.resId && this.list.length === 0) this.init(this.resId);
    },
  },
  methods: {
    getDetails(id) {
      if (!id) return;
      this.sectionList = [];
      this.list = [];
      this.$http
          .get(
            `/sat-maximization/aminocapp/aminoCaPpVOByPredictionId?predictionId=${id}&predictionType=${this.predictionTypeCode}`
          )
          .then((res) => {
            let { success, data=[] } = res || {};
            if (success) {
              //动态生成头部区间
              let list = []
              if(!data || !data.length){
                return
              }
              data.forEach((el) => {
                this.sectionList.push({
                  name: `${el.initialDayinput}-${el.finalDayinput}天`,
                  field: `${el.initialDayinput}-${el.finalDayinput}`,
                });
                this.fixedArr.push(`avg${el.initialDayinput}-${el.finalDayinput}Req`);
                this.fixedArr.push(`avg${el.initialDayinput}-${el.finalDayinput}ReqDay`);
                this.fixedArr.push(`Ratio${el.initialDayinput}-${el.finalDayinput}`);
                this.fixedArr.push(`Diet${el.initialDayinput}-${el.finalDayinput}`);
              }); 
              
            this.formulaNameArray=data

            this.aminoAcidList.forEach((item) => {
              if (item.name === "磷（P）") {
                item.name = this.animationP;
              }
              let obj = {
                name: item.name,
              };
              
                data.forEach((el) => {
                  if(item.field === 'Ca'){
                    obj[`avg${el.initialDayinput}-${el.finalDayinput}Req`] = el.caReq
                    obj[`avg${el.initialDayinput}-${el.finalDayinput}ReqDay`] = el.caReqDay
                    obj[`Ratio${el.initialDayinput}-${el.finalDayinput}`] = '-';
                    obj[`Diet${el.initialDayinput}-${el.finalDayinput}`] = el["diet" + item.field];
                  }else if(item.field === 'LysofE'){
                    obj[`Diet${el.initialDayinput}-${el.finalDayinput}`] = '-';
                    obj[`avg${el.initialDayinput}-${el.finalDayinput}Req`] = '-'
                    obj[`avg${el.initialDayinput}-${el.finalDayinput}ReqDay`] = '-'
                    obj[`Ratio${el.initialDayinput}-${el.finalDayinput}`] = el.lysofE;
                  }else if(item.field === 'P'){
                    obj[`avg${el.initialDayinput}-${el.finalDayinput}Req`] = el.preq
                    obj[`avg${el.initialDayinput}-${el.finalDayinput}ReqDay`] = el.preqDay
                    obj[`Ratio${el.initialDayinput}-${el.finalDayinput}`] = '-';
                    obj[`Diet${el.initialDayinput}-${el.finalDayinput}`] = el.dietP;
                  }else{
                    obj[`avg${el.initialDayinput}-${el.finalDayinput}Req`] = el["avg" + item.field + "req"] || el["avg" + item.field + "Req"];
                    if(item.field === 'Lys'){
                      obj[`avg${el.initialDayinput}-${el.finalDayinput}ReqDay`] = el.lysReqDay;
                    }else if(item.field === 'N'){
                      obj[`avg${el.initialDayinput}-${el.finalDayinput}ReqDay`] = el.nreqDay
                    }else{
                      obj[`avg${el.initialDayinput}-${el.finalDayinput}ReqDay`] = el["avg" + item.field + "ReqDay"];
                    }
                    obj[`Ratio${el.initialDayinput}-${el.finalDayinput}`] = el["ratio" + item.field];
                    obj[`Diet${el.initialDayinput}-${el.finalDayinput}`] = el["diet" + item.field];
                  }
                  obj[`Ratio${el.initialDayinput}`] = el["ratio" + item.field];
                  obj[`Diet${el.initialDayinput}`] = el["diet" + item.field];
                })
              
              list.push(obj);
            })
            this.list = list;
          }
        });
    },
    init() {
      if (this.estimateId && this.isAdd) {
        this.getDetails(this.estimateId);
        this.getName(this.estimateId);
      } else if (!this.isAdd && this.resId) {
        this.getDetails(this.resId);
        this.getName(this.resId);
      }
    },

    //获取磷，氨基酸名称
    getName() {
      let { prediction } = this.details;
      let { phosphorusSystem, aminoAcidSystem } = prediction;
      let obj = this.dataDictionary.PhosphorusSystem.find(
        (el) => el.dictKey === phosphorusSystem
      );
      let obj1 = this.dataDictionary.AminoAcidSystem.find(
        (el) => el.dictKey == aminoAcidSystem
      );
      this.animationP = obj.dictValue || " ";
      
      if(obj1.dictValue.includes("-AA")){
        this.aminoAcidName = obj1.dictValue.replace("-AA", "").replace("氨基酸","") || " ";
      }else{
        this.aminoAcidName="总"
      }
    },
  },
};
</script>